import React from 'react'
import { Modal } from '@/components/ui/Modal'
import { Button } from '@/components/ui/button'

interface ConfirmDeleteDialogProps {
  open: boolean
  entityLabel: string
  entityName?: string
  onConfirm: () => Promise<void> | void
  onClose: () => void
  loading?: boolean
}

export const ConfirmDeleteDialog: React.FC<ConfirmDeleteDialogProps> = ({
  open,
  entityLabel,
  entityName,
  onConfirm,
  onClose,
  loading = false,
}) => {
  return (
    <Modal isOpen={open} onClose={onClose} title={`Delete ${entityLabel}`} size="sm">
      <div className="space-y-4">
        <p className="text-sm text-secondary-700">
          Are you sure you want to delete{' '}
          <span className="font-semibold text-secondary-900">
            {entityName ?? `this ${entityLabel.toLowerCase()}`}
          </span>
          ? This action cannot be undone.
        </p>

        <div className="flex justify-end gap-2 pt-2">
          <Button type="button" variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button type="button" variant="destructive" onClick={onConfirm} disabled={loading}>
            {loading ? 'Deleting...' : `Delete ${entityLabel}`}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
